<template>
  <div v-if="field">
    <div class="user-info__wrapper" v-if="field.type === 'string'">
      <r-text type="caption">
        {{ $t(`user-info:input-${field.value}`) }}
        <r-text
          type="caption"
          style="display: inline"
          v-if="field.value !== 'middle_name' && field.value !== 'position'"
        >
          *
        </r-text>
      </r-text>
      <div class="user-info__block-row__content">
        <el-input
          :disabled="field.value === 'name' && !isCreateUser"
          size="mini"
          :placeholder="$t(`user-info:input-${field.value}`)"
          class="r-input"
          v-model="user[field.value]"
        />
      </div>
    </div>
    <div class="user-caption-2" v-else-if="field.type === 'email'">
      <r-text type="caption">
        {{ $t(`user-info:input-${field.value}`) }}
        <r-text type="caption" style="display: inline">*</r-text>
      </r-text>
      <div class="user-info__block-row__content">
        <el-input
          type="email"
          size="mini"
          name="email"
          :placeholder="$t(`user-info:input-${field.value}`)"
          class="r-input"
          v-model="user[field.value]"
        />
      </div>
    </div>
    <div class="user-info__wrapper" v-else-if="field.type === 'date'">
      <r-text type="caption">
        {{ $t(`user-info:input-${field.value}`) }}
      </r-text>
      <div class="user-info__block-row__content">
        <el-date-picker
          class="r-date-picker"
          v-model="user[field.value]"
          type="datetime"
          size="mini"
          name="datetime"
          clearable
          format="dd.MM.yyyy HH:mm"
          :placeholder="$t(`user-info:input-${field.value}`)"
          :disabled="module === 'account'"
        />
      </div>
    </div>
    <div class="user-info__wrapper" v-else-if="field.type === 'checkbox'">
      <div class="user-info__block-row__content">
        <el-checkbox class="r-checkbox" size="mini" v-model="user[field.value]">
          <r-text type="caption">
            {{ $t(`user-info:input-${field.value}`) }}
          </r-text>
        </el-checkbox>
      </div>
    </div>
    <div class="user-info__wrapper" v-else-if="field.type === 'password'">
      <r-text type="caption">
        {{ $t(`user-info:input-${field.value}`) }}
      </r-text>
      <div class="user-info__block-row__content">
        <form autocomplete="off">
          <el-input
            show-password
            size="mini"
            name="password"
            :placeholder="$t(`user-info:input-${field.value}`)"
            auto-complete="new-password"
            class="r-input"
            v-model="user[field.value]"
          />
        </form>
      </div>
    </div>
    <div
      class="user-info__wrapper"
      v-else-if="field.type === 'role_name' && instance === 'tagil'"
    >
      <r-text type="caption">
        {{ $t(`user-info:input-${field.value}`) }}
      </r-text>
      <div class="user-info__block-row__content">
        <el-select
          class="r-select"
          v-model="user[field.value]"
          :placeholder="$t(`user-info:input-${field.value}`)"
          filterable
          clearable
          size="mini"
        >
          <el-option
            v-for="item in userRolesList"
            :key="item.id"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { userRolesList } from "../configs/";

export default {
  props: { field: Object, user: Object, module: String },
  data() {
    return {
      userRolesList
    };
  },
  computed: {
    isCreateUser() {
      return this.$store.state.userRoles.isCreateUser;
    },
    instance() {
      return this.$store.state.instance;
    }
  }
};
</script>

<style lang="scss">
.user-info {
  .r-input {
    &.is-disabled {
      input {
        background-color: var(--bg_panel_primary) !important;
        opacity: 1 !important;
      }
    }
  }
  .r-select {
    width: 100%;
  }
  .r-text {
    margin-bottom: 4px;
  }
}
</style>

<i18n>
{
  "ru": {
    "user-info:input-name": "Логин",
    "user-info:input-email": "Электронная почта",
    "user-info:input-last_name": "Фамилия",
    "user-info:input-first_name": "Имя",
    "user-info:input-middle_name": "Отчество",
    "user-info:input-company": "Компания",
    "user-info:input-position": "Должность",
    "user-info:input-valid_until": "Срок действия аккаунта",
    "user-info:input-admin": "Права системного администратора",
    "user-info:input-password": "Пароль",
    "user-info:input-role_name": "Роль"
  },
  "en": {
    "user-info:input-name": "Login",
    "user-info:input-email": "Email",
    "user-info:input-last_name": "Last name",
    "user-info:input-first_name": "First name",
    "user-info:input-middle_name": "Middle name",
    "user-info:input-company": "Company",
    "user-info:input-position": "Position",
    "user-info:input-valid_until": "Account expiration date",
    "user-info:input-admin": "System admin rights",
    "user-info:input-password": "Password",
    "user-info:input-role_name": "Role"
  }
}
</i18n>
